import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown12 } from 'shared/assets/icons';
import { Size } from 'shared/components/ui/custom-form-select';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './date-button.style';

export interface DateButtonProps {
  value: string | Date | null;
  placeholder?: string;
  onClick: () => void;
  dateFormat: string;
  size?: Size;
  noBorders?: boolean;
  inheritColor?: boolean;
}

export const DateButton = React.forwardRef<HTMLDivElement, DateButtonProps>(
  (
    {
      value,
      placeholder,
      onClick,
      dateFormat,
      size = Size.ExtraSmall,
      noBorders = false,
      inheritColor = false,
    },
    ref,
  ) => {
    const { t } = useTranslation();

    const displayValue = () => {
      if (value instanceof Date) {
        return format(value, dateFormat);
      }
      if (typeof value === 'string') {
        return value;
      }
      return null;
    };

    const currentDisplay = displayValue();

    return (
      <Styled.Container ref={ref}>
        <Styled.Button
          type="button"
          $size={size}
          $noBorders={noBorders}
          $inheritColor={inheritColor}
          $isPlaceholder={!currentDisplay}
          $noOverflow
          onClick={onClick}
        >
          {currentDisplay ?? placeholder ?? t('general.labels.select')}
        </Styled.Button>
        <Styled.InteractionContainer $size={size} $inheritColor={inheritColor}>
          <Styled.SelectIconContainer>
            <Icon icon={ChevronDown12} />
          </Styled.SelectIconContainer>
        </Styled.InteractionContainer>
      </Styled.Container>
    );
  },
);
